import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import ItemStore from '../../stores/ItemStore'
import UserStore from '../../stores/UserStore'
import OrderStore from '../../stores/OrderStore'
import Timer from './Timer'

const GrayTextTimer = ({
  timeStamp,
  text = '',
  onTimeEnd,
  interval = 100,
  timerMinutes = 60 * 24,
}) => {
  return (
    <span>
      {text}{' '}
      {Timer({ timeStamp, onTimeEnd, interval, timerMinutes }).formattedTime}
    </span>
  )
}

export default GrayTextTimer
